import common from '../commons/commons';
import Vue from 'vue';

let designStyle = [
  {
    selector: "node",
    style: {
      width: "350px",
      "text-valign": "center",
      padding: "10px",
      'min-width': "500px",
      color: "#fff",
    }
  },
  {
    selector: ".title",
    style: {
      shape: 'rectangle',
      content: "data(title)",
      'color': 'black',
      'background-opacity': 0,
      'text-color': 'black'
    }
  },
  {
    selector: ".menu",
    style: {
      content: "data(displayName)",
      shape: "round-rectangle",
    }
  },
  {
    selector: ".action",
    style: {
      content: "data(name)",
      shape: "round-rectangle",
    }
  },
  {
    selector: ".document",
    style: {
      content: "data(name)",
      shape: "round-rectangle",
    }
  },
  {
    selector: "edge",
    style: {
      "curve-style": "segments",
      opacity: "data(opacity)",
      "text-opacity": 1,
      label: "data(label)",
      "text-rotation": "autorotate",
      "text-background-color": "data(color)",
      "text-background-shape": "roundrectangle",
      "text-background-opacity": 1,
      "text-background-padding": 5,
      "text-border-opacity": 0,
      "text-border-width": 1,
      "text-border-color": "black",
      "text-border-style": "solid",
      width: 5,
      color: "black",
      "target-arrow-shape": "triangle",
      "source-arrow-shape": "none",
      "line-color": "data(lineColor)",
      "source-arrow-color": "data(lineColor)",
      "target-arrow-color": "data(lineColor)",
      "control-point-step-size": "80px",
      "target-text-offset": "0",

    }
  },
  {
    selector: "edge.option",
    style: {
      "line-style": "dashed"
    }
  },
  // some style for the extension
  {
    selector: ".eh-handle",
    style: {
      "background-color": "red",
      content: "+",
      width: 8,
      height: 8,
      shape: "circle",
      "overlay-opacity": 0,
      "border-width": 8, // makes the handle easier to hit
      "border-opacity": 0
      //"padding-top": 15,
      //"padding-bottom": 15,
    }
  },
  {
    selector: ".eh-hover",
    style: {
      "background-color": "red"
    }
  },
  {
    selector: ".eh-source",
    style: {
      "border-width": 2,
      "border-color": "red"
    }
  },
  {
    selector: ".eh-target",
    style: {
      "border-width": 2,
      "border-color": "red"
    }
  },
  {
    selector: ".eh-preview, .eh-ghost-edge",
    style: {
      "background-color": "red",
      "line-color": "red",
      "target-arrow-color": "red",
      "source-arrow-color": "red"
    }
  },
  {
    selector: ".eh-ghost-edge.eh-preview-active",
    style: {
      opacity: 0
    }
  }
];

let style = [
  {
    selector: "node",
    style: {
      width: "label",
      content: "data(name)",
      "text-valign": "center",
      padding: "10px",
      'min-width': "500px",
      color: "#fff",
      opacity: "data(opacity)"
    }
  },
  {
    selector: ".normal",
    style: {
      shape: "round-rectangle",
      "background-color": "data(color)"
    }
  },
  {
    selector: ".special",
    style: {
      shape: "circle",
      height: 60,
      width: 60,
      "background-color": "#73cae0"
    }
  },
  {
    selector: ":selected",
    style: {
      "border-width": 2,
      "border-color": "#333"
    }
  },
  {
    selector: "edge",
    style: {
      "curve-style": "bezier",
      opacity: "data(opacity)",
      "text-opacity": 1,
      label: "data(label)",
      // "text-rotation": "autorotate",
      "text-background-color": "data(color)",
      "text-background-shape": "roundrectangle",
      "text-background-opacity": 1,
      "text-background-padding": 5,
      "text-border-opacity": 0,
      "text-border-width": 1,
      "text-border-color": "black",
      "text-border-style": "solid",
      width: 5,
      color: "black",
      "target-arrow-shape": "triangle",
      "source-arrow-shape": "none",
      "line-color": "data(lineColor)",
      "source-arrow-color": "data(lineColor)",
      "target-arrow-color": "data(lineColor)",
      "control-point-step-size": "80px",
      // "target-text-offset": "0",
      'loop-direction': '60deg',
      'loop-sweep': '45deg',
      // 'control-point-distances': edge => edge.data('distances') || [0, 0],
      // 'control-point-weights': [0, 0.2],
      // 'segment-distances': edge => edge.data('distances') || [0, 0],
      // 'segment-weights': [0, 0.2],
      // 'edge-distances': 'node-position',
      // 'source-endpoint': '180deg',
      // 'target-endpoint': '0deg'
      "curve-style": "data(curveStyle)",
      "segment-distances": "data(cyedgebendeditingDistances)",
      "segment-weights": "data(cyedgebendeditingWeights)",
    }
  },
  {
    selector: "edge.option",
    style: {
      "line-style": "dashed"
    }
  },
  // some style for the extension
  {
    selector: ".eh-handle",
    style: {
      "background-color": "red",
      content: "+",
      width: 8,
      height: 8,
      shape: "circle",
      "overlay-opacity": 0,
      "border-width": 8, // makes the handle easier to hit
      "border-opacity": 0
      //"padding-top": 15,
      //"padding-bottom": 15,
    }
  },
  {
    selector: ".eh-hover",
    style: {
      "background-color": "red"
    }
  },
  {
    selector: ".eh-source",
    style: {
      "border-width": 2,
      "border-color": "red"
    }
  },
  {
    selector: ".eh-target",
    style: {
      "border-width": 2,
      "border-color": "red"
    }
  },
  {
    selector: ".eh-preview, .eh-ghost-edge",
    style: {
      "background-color": "red",
      "line-color": "red",
      "target-arrow-color": "red",
      "source-arrow-color": "red"
    }
  },
  {
    selector: ".eh-ghost-edge.eh-preview-active",
    style: {
      opacity: 0
    }
  }
];


let getDesignNodes = function (menus, actions, documents) {
  let menuNodes = menus
    .map(function (x, ind) {
      return { data: x, classes: "menu", position: { x: 700, y: (ind) * 80 + 180 } };
    });

  let actionNodes = actions
    .map(function (x, ind) {
      return { data: x, classes: "action", position: { x: 200, y: (ind) * 80 + 180 } };
    });

  let documentNodes = documents
    .map(function (x, ind) {
      return { data: x, classes: "document", position: { x: 1200, y: (ind) * 80 + 180 } };
    });

  let titles = [
    { data: { id: 'action', title: 'Action' }, classes: 'title', position: { x: 200, y: 100 } },
    { data: { id: 'menu', title: 'Menu' }, classes: 'title', position: { x: 700, y: 100 } },
    { data: { id: 'document', title: 'Document' }, classes: 'title', position: { x: 1200, y: 100 } },
  ]

  return titles.concat(menuNodes)
    .concat(actionNodes)
    .concat(documentNodes);
}

var findPosition = function (diagram, id) {
  var node = diagram.find(x => x.id == id);
  if (node) {
    return node.position;
  }

  return {}
}

let getNodes = function (states, flows, selection, designer) {
  let nodes = [];
  if (designer) {
    nodes = designer.nodes;
  }


  var specials = [
    {
      id: "start",
      name: "start",
      classes: "special"
    },
    {
      id: "any",
      name: "any",
      classes: "special"
    },
    {
      id: "change",
      name: "change",
      classes: "special"
    }
  ];

  let result = (specials.concat(states))
    .map(function (x) {
      x.position = findPosition(nodes, x.id);

      return {
        id: x.id,
        name: x.name,
        data: x,
        classes: x.classes ? x.classes : "normal",
        position: findPosition(nodes, x.id),
      };
    })


  let nodeIds = [];
  if (selection) {
    if (selection.type == 'activity') {
      let selectedFlows = flows.filter(x => x.activityId == selection.item);
      selectedFlows.forEach(flow => {
        nodeIds.push(flow.fromStateId);
        if (flow.conditional) {
          nodeIds = nodeIds.concat(flow.conditionalStates.map(x => x.toStateId));
        } else {
          nodeIds.push(flow.toStateId);
        }
      });
    } else if (selection.type == 'state') {
      nodeIds.push(selection.item);
    }
  }

  result.forEach(node => {
    node.data.opacity = 1;



    if (selection && selection.item && selection.type) {
      node.data.opacity = 0.4;
      if (nodeIds.some(x => node.data.id == x)) {
        node.data.opacity = 1;
      }
    }
  });

  return result;
}

let getEdges = function (activities, states, flows, selection, diagram) {
  if (!flows) flows = [];

  var directs = flows
    .filter(function (x) {
      return !x.conditional;
    })
    .map(function (x) {
      return {
        data: {
          id: x.id,
          flowId: x.id,
          flow: x,
          activityId: x.activityId,
          source: x.fromStateId,
          target: x.toStateId ? x.toStateId : 'any'
        },
      };
    });

  if (states.some(x => x.initial)) {
    directs.push({
      data: {
        id: common.nanoID(),
        source: 'start',
        target: states.find(x => x.initial).id

      }
    })
  }

  var onlyThroughChanges = states.filter(x =>
    !flows.some(y => y.fromStateId == x.id)
    && !flows.some(y => y.toStateId == x.id));

  onlyThroughChanges.forEach(change => {
    directs.push({
      data: {
        id: common.nanoID(),
        source: 'change',
        label: 'change',
        target: change.id
      }
    })
  });


  var conditionals = flows
    .filter(function (x) {
      return x.conditional;
    })
    .map(function (x) {
      var result = x.conditionalStates.map(function (y) {
        return {
          data: {
            id: y.id,
            flowId: x.id,
            flow: x,
            activityId: x.activityId,
            source: x.fromStateId,
            target: y.toStateId,
            conditional: true
          },
          classes: "option"
        };
      });
      return result;
    })
    .reduce(function (a, b) {
      return a.concat(b);
    }, []);

  var edges = directs.concat(conditionals);
  edges.forEach(function (x) {
    x.data.color = "white";
    x.data.lineColor = "gray";
    x.data.curveStyle = 'bezier';
    if(x.data.cyedgebendeditingDistances
      && x.data.cyedgebendeditingDistances.length > 0) {
        x.data.curveStyle = 'segments';
    }

    if (!x.data.label) {
      x.data.label = "create";
    }

    x.data.opacity = 0.95;

    if (selection && selection.type && selection.item) {
      x.data.opacity = 0.15;
    }

    if (x.data.activityId == null && x.data.source == null) {
      x.data.source = "start";
    } else if (x.data.activityId != null && x.data.source == null) {
      x.data.source = "any";
    }

    var state = states.find(function (state) {
      return state.id == x.data.source;
    });
    if (state) {
      x.data.lineColor = state.color;
    }

    var activity = activities.find(function (activity) {
      return activity.id == x.data.activityId;
    });

    if (activity) {
      x.data.activity = activity;

      if (selection) {
        switch (selection.type) {
          case 'information':
            if (activity.classification.some(x => x.id == selection.item)) {
              x.data.opacity = 0.95;
            }
            break;

          case 'activity':
            if (activity.id == selection.item) {
              x.data.opacity = 0.95;
            }
            break;

          case 'state':
            if (x.data.source == selection.item) {
              x.data.opacity = 0.95;
            }
            break;
        }
      }



      if (activity.name) {
        x.data.label =
          (activity.emoji ? activity.emoji + " " : "") + activity.name;
      }

      if (x.data.activity.color) x.data.color = x.data.activity.color;
    }
  });


  let diagramEdges = [];
  if (diagram && diagram.edges) {
    diagramEdges = diagram.edges;
  }

  edges.forEach((edge) => {
    let diagramEdge = diagramEdges.find(x => x.id == edge.data.id 
      || (x.source == edge.data.source && x.target == edge.data.target));
    if(diagramEdge) {
      edge.data.cyedgebendeditingDistances = diagramEdge.cyedgebendeditingDistances;
      edge.data.cyedgebendeditingWeights = diagramEdge.cyedgebendeditingWeights;
      if(edge.data.cyedgebendeditingDistances
        && edge.data.cyedgebendeditingDistances.length > 0) {
          edge.data.curveStyle = 'segments';
      }
    }
  });


  // edges[0].data.curveStyle = 'segments';
  // edges[0].data.cyedgebendeditingDistances = [127.3186651296108]
  // edges[0].data.cyedgebendeditingWeights = [0.8341858178901047]


  return edges;
}

export default {
  style,
  designStyle,
  getNodes,
  getEdges,
  getDesignNodes,
}